<template>
    <div class="container-fluid py-4">
      <template v-if="!isLoading">
        <div class="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4 pb-3 border-bottom">
          <div>
            <h4 class="text-success mb-1">Detalles del Infante</h4>
            <p class="text-sm text-secondary mb-0">
              Trabajador:
              <a class="font-weight-bold" :href="`/trabajadores/${infant.customer.id}`">
                {{ infant.customer?.name || (infant.customer?.first_name + ' ' + infant.customer?.last_name) }}
              </a>
            </p>
          </div>
          <div class="d-flex flex-wrap gap-2">
            <template v-if="readOnly">
              <button @click="readOnly = false" class="btn btn-info mb-0">Editar Registro</button>
              <button class="btn btn-primary mb-0" @click="printPDF">
                <template v-if="downloading">Imprimiendo ...</template>
                <template v-else>Imprimir Kardex</template>
              </button>
            </template>
            <template v-else>
              <button @click="readOnly = true" class="btn btn-secondary mb-0">Descartar</button>
              <button @click.stop="update" class="btn btn-success mb-0">Guardar</button>
            </template>
            <button @click.stop="deleteInfant" class="btn btn-danger mb-0">Eliminar</button>
          </div>
        </div>
        <div class="row d-flex">
          <div class="col-xs-12 col-lg-8">
            <div class="mb-3">
              <label class="form-label text-primary">Nombre completo</label>
              <input type="text" class="form-control" v-model="infant.first_name" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Edad</label>
              <input type="text" class="form-control" v-model="infant.age" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Condición Médica</label>
              <input type="text" class="form-control" v-model="infant.allergy" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Equipo</label>
              <select v-if="!readOnly" class="form-control" v-model="selectedTeamId">
                <option :value="null">— Selecciona un equipo —</option>
                <option v-for="option in teams" :value="option.id" :key="option.id">{{ option.name }}</option>
              </select>
              <input v-if="readOnly && selectedTeam" type="text" class="form-control" :value="selectedTeam.name" :disabled="true">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Nivel</label>
              <input type="text" class="form-control" :value="selectedTeam?.level || ''" :disabled="true">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Responsable Nombre</label>
              <input type="text" class="form-control" v-model="infant.person_name" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Responsable Telefono</label>
              <input type="text" class="form-control" v-model="infant.person_phone" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Responsable Parentesco</label>
              <input type="text" class="form-control" v-model="infant.person_relationship" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Sede</label>
              <select v-if="!readOnly" class="form-control" v-model="selectedCampusId">
                <option :value="null">— Selecciona una sede —</option>
                <option v-for="campus in campuses" :value="campus.id" :key="campus.id">{{ campus?.name }}</option>
              </select>
              <input v-if="readOnly && selectedCampus" type="text" class="form-control" :value="selectedCampus.name" :disabled="true">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Ruta</label>
              <select v-if="!readOnly" class="form-control" v-model="selectedRouteId">
                <option :value="null">— Selecciona una ruta —</option>
                <option v-for="route in routes" :value="route.id" :key="route.id">{{ route.name }}</option>
              </select>
              <input v-if="readOnly && selectedRoute" type="text" class="form-control" :value="selectedRoute.name" :disabled="true">
            </div>
          </div>
          <div class="col-12">
            <h6 class="text-primary mt-2">Datos del trabajador <small class="text-secondary">(se editan en la ficha del trabajador)</small></h6>
          </div>
          <div class="col-xs-12 col-lg-3">
            <div class="mb-3">
              <label class="form-label text-secondary">Matrícula</label>
              <input type="text" class="form-control" :value="infant.customer?.matricula" disabled>
            </div>
          </div>
          <div class="col-xs-12 col-lg-3">
            <div class="mb-3">
              <label class="form-label text-secondary">Área/supervisor</label>
              <input type="text" class="form-control" :value="infant.customer?.area" disabled>
            </div>
          </div>
          <div class="col-xs-12 col-lg-3">
            <div class="mb-3">
              <label class="form-label text-secondary">Teléfono</label>
              <input type="text" class="form-control" :value="infant.customer?.phone" disabled>
            </div>
          </div>
          <div class="col-xs-12 col-lg-3">
            <div class="mb-3">
              <label class="form-label text-secondary">Correo</label>
              <input type="text" class="form-control" :value="infant.customer?.email" disabled>
            </div>
          </div>

          <h6 class="text-primary">Ingresos</h6>
          <table class="table table-bordered schedule">
            <thead>
              <tr>
                <th>Dia y hora</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(entrance,index) in infant.entrances" :key="index">
                <td>{{ formatDate(entrance.created_at) }}</td>

              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <template v-else>
        <p>Cargando datos...</p>
      </template>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  const PUBLIC_API_URL = process.env.VUE_APP_PUBLIC_API_URL;
  import moment from "moment"
  import es from "moment/dist/locale/es";
  moment.updateLocale("es", es);
  export default {
    name: 'InfantDetails',
    data() {
      return {
        infant: null,
        isLoading: false,
        readOnly: true,
        teams: [],
        campuses: [],
        routes: [],
        selectedTeamId: null,
        selectedCampusId: null,
        selectedRouteId: null
      };
    },
    created() {
      this.fetchInfantDetails();
    },
    computed: {
      selectedTeam() {
        return this.teams.find(t => t.id === this.selectedTeamId) || null;
      },
      selectedCampus() {
        return this.campuses.find(c => c.id === this.selectedCampusId) || null;
      },
      selectedRoute() {
        return this.routes.find(r => r.id === this.selectedRouteId) || null;
      },
    },
    methods: {
      async fetchInfantDetails() {
        this.isLoading = true;
        const id = this.$route.params.id;
    
        try {
          const response = await axios.get(`${PUBLIC_API_URL}/infants/${id}`);
          const responseRecord = await axios.get(`${PUBLIC_API_URL}/records/infants`);
          this.infant = response.data;

          // Nombre completo en un solo campo: registros viejos con apellido
          // separado se fusionan en first_name y last_name queda en null.
          this.infant.first_name = [this.infant.first_name, this.infant.last_name]
            .filter(Boolean).join(' ').trim();
          this.infant.last_name = null;

          this.teams = responseRecord.data.teams;
          this.routes = responseRecord.data.routes;
          this.campuses = responseRecord.data.campuses;

          // Apuntar al objeto del catalogo (misma referencia) para que el <select>
          // muestre el valor seleccionado al editar.
          const currentTeam = this.infant?.teams?.[0];
          if (currentTeam) {
            this.selectedTeamId = this.teams.some(t => t.id === currentTeam.id) ? currentTeam.id : null;
          }
          const currentCampus = this.infant?.campuses?.[0];
          if (currentCampus) {
            this.selectedCampusId = this.campuses.some(c => c.id === currentCampus.id) ? currentCampus.id : null;
          }
          const currentRoute = this.infant?.routes?.[0];
          if (currentRoute) {
            this.selectedRouteId = this.routes.some(r => r.id === currentRoute.id) ? currentRoute.id : null;
          }
            
        } catch (error) {
          this.$swal({
            title: "Ocurrio un error!",
            text: "No pudimos obtener los datos del infantil!",
            icon: "error"
          });
        }
        
        this.isLoading = false;
      },
      async update(){
        
        this.isLoading = true;
        try {
          const payload = {
            ...this.infant,
            'team_id': this.selectedTeamId,
            'route_id': this.selectedRouteId,
            'campus_id': this.selectedCampusId
          }
          const response = await axios.put(`${PUBLIC_API_URL}/infants/${this.infant.id}`, payload);
          this.infant = response.data;
          this.fetchInfantDetails()
          this.readOnly = true
          this.$swal({
            title: "Actualizado con Exito!",
            text: "Los datos del infantil fueron actualizados!",
            icon: "success"
          });
        } catch (error) {
          this.$swal({
            title: "Ocurrio un error!",
            text: "No pudimos actualizar los datos del infantil!",
            icon: "error"
          });
        }
      },
      printPDF() {
        try {
          this.downloading = true;
          const id = this.$route.params.id;
          const url = `${PUBLIC_API_URL}/infants/${id}/pdf`;
          const link = document.createElement('a');
          link.href = url;
          document.body.appendChild(link);
          link.click();
          this.downloading = false;
        } catch (error) {
          this.$swal({
            title: "Ocurrio un error!",
            text: error,
            icon: "error"
          });
          this.downloading = false;
        }
      },
      formatDate(date){
        let localTime = moment.utc(date).toDate();
        return moment(localTime).format('LLLL');
      },
      async deleteInfant() {
        const result = await this.$swal({
          title: "¿Eliminar infante?",
          text: "Esta acción no se puede deshacer.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#dc3545",
        });

        if (!result.isConfirmed) return;

        try {
          await axios.delete(`${PUBLIC_API_URL}/infants/${this.infant.id}`);
          this.$swal({
            title: "Eliminado con Éxito!",
            text: "El infante fue eliminado.",
            icon: "success"
          });
          this.$router.push('/recreativo-infantil');
        } catch (error) {
          this.$swal({
            title: "Ocurrio un error!",
            text: "No pudimos eliminar al infante!",
            icon: "error"
          });
        }
      }
    }
  };
  </script>
  
  <style scoped>

  </style>
  
